/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class ChooseRolePopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }
}
